<template>
<div
  class="ticket-print"
  :id="printId"
>
  <ticket-document
    v-if="!loading"
    :loading="loading"
    :config="config"
    :ticket="ticket"
  />
</div>
</template>
<script>
import {mapActions} from 'vuex'
import TicketDocument from './TicketDocument'

export default {
  name: 'TicketPrint',

  components: {
    TicketDocument
  },

  data () {
    return {
      ticket: {},
      loading: true
    }
  },

  computed: {
    id () {
      return this.$route.params.id
    },

    printId: function () {
      return `ticket-print-${this.ticket.barcode}`
    },

    config: {
      get () {
        return this.$store.state.config
      }
    }
  },

  methods: {
    ...mapActions('tickets', { fetchTicket: 'fetchOne' }),
    ...mapActions('events', { fetchEvent: 'fetchOne' }),
    ...mapActions('customers', { fetchCustomer: 'fetchOne' }),
    fetch () {
      this.loading = true
      this.fetchTicket(this.id).then(ticketData => {
        this.fetchCustomer(ticketData.customerId).then(customer => {
          this.fetchEvent(ticketData.eventId).then(event => {
            this.ticket = Object.assign(ticketData, { customer }, { event })
            this.loading = false
          })
        })
      }).catch(err => {
        console.log(err)
        this.loading = false
        return err
      })
    }
  },

  mounted () {
    this.fetch()
  }
}
</script>
<style scoped>
  .ticket-print {
    font-size: 8pt;
  }

  strong {
    font-weight: bolder;
  }

  @page {
    size: A4 portrait;
    margin: 1em;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/DocumentTicket.vue